import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { Role } from "./role";

@JsonConverter
export class TenantConverter implements JsonCustomConvert<Tenant>{
	serialize() { }
	deserialize(data: any): Tenant {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, Tenant);
	}
}

@JsonConverter
export class TenantArrayConverter implements JsonCustomConvert<Array<Tenant>>{
	serialize() { }
	deserialize(data: any):Array<Tenant> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, Tenant);
	}
}

@JsonObject("Tenant")
export class Tenant{
    @JsonProperty("uuid", String, true)
	uuid: string = "";
	@JsonProperty("name", String, true)
	name: string = "";
}